"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Share = function Share() {
  return _react2.default.createElement(
    "g",
    { id: "share" },
    _react2.default.createElement("path", {
      d: "M500,219.9 L300.7,36 L300.7,139.6 C75.4,123.3 0,368.8 0,445.2 L0,464.5 C75.4,292.5 244.3,292.5 300.7,292.5 L300.7,403.8 L500,219.9 L500,219.9 Z",
      id: "Shape"
    })
  );
};

exports.default = Share;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Share.js
// module id = 2987
// module chunks = 4